import React, { useState } from 'react';
import { useOnboarding } from '../OnboardingContext';

export default function StepRoles({ onNext }) {
  const { state, merge } = useOnboarding();
  const [departments, setDepartments] = useState(state.departments || []);

  const [newDept, setNewDept] = useState('');
  const [newRole, setNewRole] = useState('');
  const [activeDept, setActiveDept] = useState(departments[0]?.id || null);

  const createDept = () => {
    if (!newDept.trim()) return;
    const id = newDept.trim().toLowerCase().replace(/\s+/g, '-');
    const d = { id, name: newDept.trim(), roles: [] };
    const next = [...departments, d];
    setDepartments(next);
    setNewDept('');
    setActiveDept(id);
  };

  const addRole = () => {
    if (!newRole.trim() || !activeDept) return;
    const next = departments.map((d) => d.id === activeDept ? { ...d, roles: [...d.roles, newRole.trim()] } : d);
    setDepartments(next);
    setNewRole('');
  };

  const removeRole = (deptId, idx) => {
    const next = departments.map((d) => d.id === deptId ? { ...d, roles: d.roles.filter((_, i) => i !== idx) } : d);
    setDepartments(next);
  };

  const handleNext = () => {
    merge({ departments });
    if (typeof onNext === 'function') onNext();
  };

  // Keep local UI in sync with onboarding state (if user navigates back)
  React.useEffect(() => {
    if (state.departments) setDepartments(state.departments);
  }, [state.departments]);

  return (
    <div style={{ padding: 24 }}>
      <h3>Roles & Departments</h3>

      <div style={{ display: 'flex', gap: 24 }}>
        <div style={{ minWidth: 200 }}>
          <h4>Departments</h4>
          <ul>
            {departments.map((d) => (
              <li key={d.id} style={{ marginBottom: 6 }}>
                <button
                  type="button"
                  onClick={() => setActiveDept(d.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    color: '#1976d2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    font: 'inherit',
                  }}
                >
                  {d.name}
                </button>
              </li>
            ))}
          </ul>
          <div style={{ marginTop: 8 }}>
            <input value={newDept} onChange={(e) => setNewDept(e.target.value)} placeholder="New department" />
            <button onClick={createDept} style={{ marginLeft: 6 }}>Add Dept</button>
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <h4>Roles</h4>
          {departments.map((d) => (
            <div key={d.id} style={{ display: d.id === activeDept ? 'block' : 'none' }}>
              <h5>{d.name}</h5>
              <ul>
                {d.roles.map((r, i) => (
                  <li key={i}>{r} <button onClick={() => removeRole(d.id, i)} style={{ marginLeft: 8 }}>Remove</button></li>
                ))}
              </ul>
              <div style={{ marginTop: 8 }}>
                <input value={newRole} onChange={(e) => setNewRole(e.target.value)} placeholder="New role" />
                <button onClick={addRole} style={{ marginLeft: 6 }}>Add Role</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <button onClick={handleNext}>Next</button>
      </div>
    </div>
  );
}
